var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "firstmilemgmt"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_c('b', [_vm._v("PRS ID :")]), _vm._v(" " + _vm._s(_vm.prsid))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_c('b', [_vm._v("FM Shipments in Trip :")]), _vm._v(_vm._s(_vm.FMcount))])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("Total Records: " + _vm._s(_vm.FMcount))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('custom-expandable-table', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "columns": _vm.tableColumn,
      "isEditHidden": true,
      "items": _vm.tableItems,
      "innerTableHeader": _vm.innerTableColumn,
      "offset": _vm.offset
    },
    on: {
      "customTableEvent": _vm.getCustomTableEvent
    }
  })], 1)])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43ef70f4","hasScoped":true}!./src/modules/firstAndLastmilemanagement/views/TripManagement/CreateTripManagement/TripShipment/firstmileShipment/firstmileShipment.component.html
// module id = 1334
// module chunks = 3